import { BASE_URL } from "../../../utils/constants";
import { tt } from "../../../utils/i18n/i18n";
import React, { ReactNode } from "react";

interface SignUpLayoutProps {
  children: ReactNode;
}

export default function (props: SignUpLayoutProps) {
  return (
    <>
      <img
        src={`${BASE_URL}/background/bg_01_1.png`}
        className="auth-bg"
        alt={tt("signup_background_image_alt")}
      />

      <div className="signup-container">
        <div className="auth-logo-container">
          <img
            alt={tt("signup_logo_alt")}
            src={`${BASE_URL}/img/logo/kadow_1_line.png`}
            className="logo-kadow"
          />
        </div>
        <div className={"mx-auto d-flex flex-column signup-content"}>
          {props.children}
        </div>
      </div>
    </>
  );
}
